import { LoadingAnimationHOC } from "@tinqin/tinqin-ui-components/src/loading-animation";
import internalStateService from "../../app/InternalStateService";
import { LoadingAnimation } from "./WidgetLoading";

const loadingProps = () => {
    let defaultData = {
        fadeinTime: 0,
        fadeoutTime: 500,
        contentRenderWaitingTime: 0,
        fadeAnimation: true
    };
    if (internalStateService.getComponentsDefaultConfig()["flowWidgetLoading"]) {
        return Object.assign(
            defaultData,
            internalStateService.getComponentsDefaultConfig()["flowWidgetLoading"]
        );
    } else return defaultData;
};

export default LoadingAnimationHOC(LoadingAnimation, loadingProps);
